import React from 'react';
import DefaultLayout from '../../layouts/default';

// Import Overview Banner & Header Row
import ComplianceCentreOverview from './components/ComplianceCentreOverview';

// Import Left Main Column Components
import ComplianceAreasOverview from './components/ComplianceAreasOverview';
import DashboardActivitySection from './components/DashboardActivitySection';

// Import Right Sidebar Widgets
import InspectorAccessWidget from './components/InspectorAccessWidget';
import UpcomingEvents from './components/UpcomingEvents';
import KeyDocuments from './components/KeyDocuments';
import { ComplianceCentreProvider } from './context/ComplianceCentreContext';
import ComplianceCentreDialog from './components/ComplianceCentreDialog';

function ComplianceCenterPage() {
  return (
    <ComplianceCentreProvider>
    <DefaultLayout>
      <div className="w-full min-h-screen space-y-6 font-sans antialiased">
        
        {/* 1. Full-Width Main Dashboard Header Block */}
        <section className="w-full">
          <ComplianceCentreOverview />
        </section>

        {/* 2. Structured Dual Grid Layout System */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
          
          {/* LEFT HAND MASTER STREAM PANEL (Spans 8/12 Columns) */}
          <main className="xl:col-span-8 space-y-6 w-full min-w-0">
            {/* Compliance Progress Bars Matrices Matrix */}
            <ComplianceAreasOverview />
            
            {/* Action Tables Log & Historical Live Timeline Stream */}
            <DashboardActivitySection />
          </main>

          {/* RIGHT HAND SIDEBAR METRICS PANEL (Spans 4/12 Columns) */}
          <aside className="xl:col-span-4 space-y-6 w-full">
            {/* Primary Action Tool Grid Trigger */}
            <InspectorAccessWidget />

            {/* Impending Inspection Events Queue */}
            <UpcomingEvents />

            {/* Regulatory Verification Files Folder Ledger */}
            <KeyDocuments />
          </aside>

        </div>

      </div>
      <ComplianceCentreDialog />
    </DefaultLayout>
    </ComplianceCentreProvider>
  );
}

export default ComplianceCenterPage;
